<template>
  <div class="dashboard">
    <div class="dashboard_left" :class="{ 'fullscreen' : !permissions.viewDashboardStats }">

      <div class="maps card" v-if="permissions.viewDashboardMap">

        <div class="select">
          <div class="form-group--wrap">
            <sis-select
              v-model="device_list_id"
              :options="device_list"
              :placeholder="translate('device.group.custom')"
              :label="translate('device.group.custom')"
              :clearable="false"
              @input="change_device_list_id"
            />
          </div>
        </div>

        <Maps
          :all_coords="all_coords"
          :focus = "focus"
         />
      </div>

      <div class="venta card" v-if="permissions.viewDashboardTraffic">
        <h4 class="title">
          {{ translate('dashboard.traffic.title') }}
        </h4>

        <TextTable
          :all_data = "traffic_stat"
        />
      </div>

    </div>

    <div class="dashboard_right" v-if="permissions.viewDashboardStats">

      <div class="card" v-if="Object.keys(device_groups_stat).length > 0">
        <DeviceGroupsStats :device_groups_stat="device_groups_stat"/>
      </div>

      <div class="card" v-if="Object.keys(devices_stat).length > 0">
        <DevicesStats :devices_stat="devices_stat"/>
      </div>

      <div class="card" v-if="Object.keys(simcards_stat).length > 0">
        <SimcardsStats :simcards_stat="simcards_stat"/>
      </div>

      <div class="card" v-if="Object.keys(users_stat).length > 0">
        <UsersStats :users_stat="users_stat"/>
      </div>

    </div>
  </div>
</template>
<script>
import Maps from './Maps';
import DevicesStats from './DevicesStats';
import UsersStats from './UsersStats';
import SimcardsStats from './SimcardsStats';
import DeviceGroupsStats from './DeviceGroupsStats';

import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';

export default {
  name: 'Dashboard',
  components: {
    Maps,
    TextTable,
    DevicesStats,
    UsersStats,
    SimcardsStats,
    DeviceGroupsStats
  },
  data () {
    return {
      all_coords: [],
      devices_stat: {},
      traffic_stat: {},
      users_stat: {},
      simcards_stat: {},
      device_groups_stat: {},
      focus: {},
      device_list_id: ''
    }
  },

  computed:{
    url () { return '/device/' },
    permissions(){
      return this.$store.getters.getPermissions
    },
    device_list () {
      let list = []
      for (let item of this.$store.getters.getCustomList) {
        list.push({id: item.id, label: item.name})
      }
      return list
    }
  },

  created () {
    this.dashboard_stat()
    this.dashboard_device_traffic()
    this.dashboard_device_map()
  },

  methods: {
    change_device_list_id(new_dev_list){
      if (new_dev_list !== ''){
        this.device_list_id = new_dev_list
        this.dashboard_device_map()
      }
    },
    dashboard_stat(){
      if (this.permissions.viewDashboardStats) {
        this.$http.v1.dashboardStats((response) => {
          this.devices_stat = response.data.devices_stat
          this.simcards_stat = response.data.device_simcards
          this.users_stat = response.data.users
          this.device_groups_stat = response.data.device_groups
        });
      }
    },
    async dashboard_device_traffic(){
      if (this.permissions.viewDashboardTraffic) {
        await this.$http.v1.dashboardDeviceTraffic((response) => {
          this.traffic_stat = response.data
        });
      }
    },
    dashboard_device_map(){
      if (this.permissions.viewDashboardMap) {
        let url = this.device_list_id ? 'dashboard/device-map/' + this.device_list_id : 'dashboard/device-map'
        this.$http.v1.dashboardDeviceMap(url, (response) => {
          this.device_list_id = response.data.device_list_id

          if (Object.keys(response.data.coordinates).length > 0){
            let map_stat = response.data.coordinates
            let aver_lat = 0
            let aver_lng = 0
            let count = 0
            let list = {}
            for (let map in map_stat) {
              if ( map_stat[map].last != null) {
                let item = []
                if (map_stat[map].stand === false){
                  item.push({
                    'lat': parseFloat(map_stat[map].past.lat),
                    'lng': parseFloat(map_stat[map].past.lng),
                    'ts': map_stat[map].past.ts,
                    'icon': { path: 0, scale: 3, strokeColor: '', fillColor: '', fillOpacity: 0},
                  })
                }

                item.push({
                  'lat': parseFloat(map_stat[map].last.lat),
                  'lng': parseFloat(map_stat[map].last.lng),
                  'ts': map_stat[map].last.ts,
                  'icon': ((map_stat[map].last.ts*1000 + 60*60*1000) < new Date().getTime()) ? { url: require('assets/icons/sistematics_offline.png')} : { url: require('assets/icons/sistematics_online.png')},
                  'fid': '<a href="' + this.url + map_stat[map].fid +'" style="outline: none;">' + map_stat[map].fid + '</a>',
                  'full_name': map_stat[map].full_name
                })

                aver_lat += map_stat[map].last.lat
                aver_lng += map_stat[map].last.lng

                list[map] = item
                count++
              }
            }

            this.focus = {
              'lat': aver_lat / count,
              'lng': aver_lng / count
            }
            this.all_coords = list
          }
        })
      }
    }
  },

}
</script>
<style lang="scss" scoped>
  .dashboard {
    width: 100%;
    height: 100%;
    display: flex;
    overflow-x: auto;
    &::-webkit-scrollbar {
      width: 10px;
    }

    &_left{
      width: 60%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .maps{
        height: 59%;
        .select{
          padding: 10px;
          height: 90px;
          .form-group{
            margin: 0;
          }
        }
        .card-map{
          height: calc(100% - 90px)
        }
      }
      .venta{
        height: 39%;
        padding: 5px;
        .title{
          height: 30px;
        }
        .text_table{
          height: calc(100% - 30px);
        }
      }
      &.fullscreen{
        width: 100%;
        flex-direction: row;
        .maps{
          height: 99%;
        }
        .venta{
          height: 99%;
        }
      }
    }
    &_right{
      width: 40%;
    }

    .card{
      padding-bottom: 0;
      margin: 5px;
    }
  }

  @media (max-width: 1500px){
    .dashboard {
      flex-direction: column;
      &_left{
        width: 100%;
        height: 90%;
        .maps{
          height: 49%;
        }
        .venta{
          height: 49%;
        }
        &.fullscreen{
          flex-direction: column;
          height: 100%;
          .maps{
            height: 49%;
          }
          .venta{
            height: 49%;
          }
        }
      }
      &_right{
        width: 100%;
        height: 10%;
      }
    }
  }



</style>
